import { render, staticRenderFns } from "./InstructorProfile.vue?vue&type=template&id=712b721a&scoped=true"
import script from "./InstructorProfile.vue?vue&type=script&lang=js"
export * from "./InstructorProfile.vue?vue&type=script&lang=js"
import style0 from "./InstructorProfile.vue?vue&type=style&index=0&id=712b721a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b721a",
  null
  
)

export default component.exports